export const HOME = {
    emergentLink: "home-emergent-link",
};

export const NAV = {
    root: "site-nav",
    logo: "nav-logo",
    linkAbout: "nav-link-about",
    linkFramework: "nav-link-framework",
    linkServices: "nav-link-services",
    linkWork: "nav-link-work",
    linkTestimonials: "nav-link-testimonials",
    linkTeam: "nav-link-team",
    linkPortal: "nav-link-portal",
    ctaWhatsapp: "nav-cta-whatsapp",
    mobileToggle: "nav-mobile-toggle",
    mobileLinkPortal: "nav-mobile-link-portal",
};

export const HERO = {
    root: "hero-section",
    wordmark: "hero-wordmark",
    tagline: "hero-tagline",
    stat: "hero-stat",
    subheadline: "hero-subheadline",
    ctaTrial: "hero-cta-trial",
    ctaInstagram: "hero-cta-instagram",
};

export const ABOUT = {
    root: "about-section",
    heading: "about-heading",
    badgeGst: "about-badge-gst",
    badgeMsme: "about-badge-msme",
    badgeIec: "about-badge-iec",
    address: "about-address",
};

export const CASH = {
    root: "cash-section",
    blockC: "cash-block-content",
    blockA: "cash-block-amplify",
    blockS: "cash-block-sell",
    blockH: "cash-block-hook",
};

export const SERVICES = {
    root: "services-section",
    card: (slug) => `service-card-${slug}`,
};

export const CASES = {
    root: "case-studies-section",
    grid: "case-studies-grid",
    card: (id) => `case-study-card-${id}`,
};

export const TESTIMONIALS = {
    root: "testimonials-section",
    written: "testimonials-written",
    whatsapp: "testimonials-whatsapp",
    card: (id) => `testimonial-card-${id}`,
};

export const TEAM = {
    root: "team-section",
    card: (id) => `team-card-${id}`,
};

export const HOW_IT_WORKS = {
    root: "process-section",
    step: (n) => `process-step-${n}`,
};

export const TRUST_BAR = {
    root: "trust-bar",
};

export const WHY_US = {
    root: "why-us-section",
    item: (slug) => `why-us-${slug}`,
};

export const PROMISE = {
    root: "promise-section",
};

export const FAQ = {
    root: "faq-section",
    item: (i) => `faq-item-${i}`,
};

export const TRIAL = {
    root: "trial-section",
    form: "trial-form",
    inputName: "trial-input-name",
    inputBusiness: "trial-input-business",
    inputIg: "trial-input-ig",
    inputEmail: "trial-input-email",
    inputMessage: "trial-input-message",
    submit: "trial-submit",
    whatsappBtn: "trial-whatsapp-btn",
};

export const FOOTER = {
    root: "footer-section",
    instagram: "footer-instagram",
    whatsapp: "footer-whatsapp",
    email: "footer-email",
    clientLink: "footer-client-link",
    adminLink: "footer-admin-link",
};

export const ADMIN = {
    loginRoot: "admin-login",
    loginEmail: "admin-login-email",
    loginPassword: "admin-login-password",
    loginSubmit: "admin-login-submit",
    loginError: "admin-login-error",
    dashboardRoot: "admin-dashboard",
    logout: "admin-logout",
    tabSite: "admin-tab-site",
    tabCases: "admin-tab-cases",
    tabTestimonials: "admin-tab-testimonials",
    tabTeam: "admin-tab-team",
    tabLeads: "admin-tab-leads",
    tabClients: "admin-tab-clients",
    saveSite: "admin-save-site",
    addCase: "admin-add-case",
    addTestimonial: "admin-add-testimonial",
    addTeam: "admin-add-team",
    addClient: "admin-add-client",
};

export const PORTAL = {
    loginRoot: "portal-login",
    loginEmail: "portal-login-email",
    loginPassword: "portal-login-password",
    loginSubmit: "portal-login-submit",
    loginError: "portal-login-error",
    forgotLink: "portal-forgot-link",
    forgotRoot: "portal-forgot",
    forgotEmail: "portal-forgot-email",
    forgotSubmit: "portal-forgot-submit",
    forgotSuccess: "portal-forgot-success",
    resetRoot: "portal-reset",
    resetPassword: "portal-reset-password",
    resetConfirm: "portal-reset-confirm",
    resetSubmit: "portal-reset-submit",
    dashboardRoot: "portal-dashboard",
    logout: "portal-logout",
    metricsGrid: "portal-metrics-grid",
    cardFollowers: "metric-followers",
    cardEngagement: "metric-engagement",
    cardLikes: "metric-likes",
    cardComments: "metric-comments",
    cardReels: "metric-reels",
    cardFrequency: "metric-frequency",
    hashtags: "portal-hashtags",
};
